(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define("hyDrawer", ["jQuery"], factory);
	else if(typeof exports === 'object')
		exports["hyDrawer"] = factory(require("jQuery"));
	else
		root["hyDrawer"] = factory(root["jQuery"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 